import script from "./FileView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__